
    import { defineComponent, computed, ComputedRef, reactive,  onMounted, nextTick} from "vue";
    import {useRoute} from "vue-router";
    import {useStore} from "@/store";
    import { Toast } from 'scvant';
    import {getCarSampleVideo, saveCarSampleComment, updateCarSampleVideoBad, updateCarSampleVideoGood} from '@/service';
    import '@souche-ui/cyp_aliyunplayer/lib/styles/index.css';
    import videoCom from './videoCom.vue';

    interface State {
        carName: any;
        tip: any;
        videoList: any;
        goodNum: any;
        badNum: any;
        message: any;
        lvmsg: any;
        id: any;
        tokenstr: any;
        goodType: any;
        badType: any;
    }

    export default defineComponent({
        name: "apartCourse",
        components: {
            videoCom
        },
        setup() {
            let state: State = reactive({
                carName: '',
                tip: '',
                videoList: [],
                goodNum: 0,
                badNum: 0,
                message: '',
                lvmsg: false,
                id: null,
                tokenstr: '',
                goodType: false,
                badType: false,
            });
            const {query} = useRoute();
            const {reportCode, token} = query
            state.tokenstr = decodeURIComponent(String(token));
            Toast.loading({
                duration: 0,
                forbidClick: true,
                message: '加载中...',
            });
            getCarSampleVideo({
                reportCode,
                token
            }).then((res: any) => {
                Toast.clear();
                console.log('getCarSampleVideo', res);
                state.carName = res.brandName + res.seriesName + res.modelName;
                state.tip = res.remark;
                state.videoList = res.carSampleVideoInfoVOS;
                state.goodNum = res.goodCount;
                state.badNum = res.badCount;
                state.id = res.id;
            }).catch((err) => {
                console.log(err);
            })
            return {
                state
            }
        },
        methods: {
            leaveMsg() {
                this.state.lvmsg = true;
            },
            updateMsg() {
                saveCarSampleComment({
                    comment: this.state.message,
                    id: this.state.id,
                    token: this.state.tokenstr
                }).then((res) => {
                    Toast('留言成功！');
                    this.state.message = '';
                    this.state.lvmsg = false;
                }).catch((err) => {
                    console.log(err);
                });
            },
            clickGood() {
                updateCarSampleVideoGood({
                    count: this.state.goodType ? -1 : 1,
                    id: this.state.id,
                    token: this.state.tokenstr
                }).then((res) => {
                    Toast(`${this.state.goodType ? "取消" : ''}点赞成功！`);
                    if (this.state.goodType) {
                        this.state.goodNum -= 1;
                    } else {
                        this.state.goodNum += 1;
                    }
                    this.state.goodType = !this.state.goodType;
                }).catch((err) => {
                    console.log(err);
                });
            },
            clickBad() {
                updateCarSampleVideoBad({
                    count: this.state.badType ? -1 : 1,
                    id: this.state.id,
                    token: this.state.tokenstr
                }).then((res) => {
                    Toast(`${this.state.badType ? "取消" : ''}反对成功！`);
                    if (this.state.badType) {
                        this.state.badNum -= 1;
                    } else {
                        this.state.badNum += 1;
                    }
                    this.state.badType = !this.state.badType;
                }).catch((err) => {
                    console.log(err);
                });
            }
        }
    });
